__turbopack_context__.v({
  "bottomCTA": "jobDescription-module-scss-module__mmqlOW__bottomCTA",
  "bottomCTAContent": "jobDescription-module-scss-module__mmqlOW__bottomCTAContent",
  "bulletPointWrapper": "jobDescription-module-scss-module__mmqlOW__bulletPointWrapper",
  "bulletPoints": "jobDescription-module-scss-module__mmqlOW__bulletPoints",
  "buttonContainer": "jobDescription-module-scss-module__mmqlOW__buttonContainer",
  "centered": "jobDescription-module-scss-module__mmqlOW__centered",
  "container": "jobDescription-module-scss-module__mmqlOW__container",
  "enter": "jobDescription-module-scss-module__mmqlOW__enter",
  "enterFrom": "jobDescription-module-scss-module__mmqlOW__enterFrom",
  "enterTo": "jobDescription-module-scss-module__mmqlOW__enterTo",
  "gdpr": "jobDescription-module-scss-module__mmqlOW__gdpr",
  "gdprLink": "jobDescription-module-scss-module__mmqlOW__gdprLink",
  "hero": "jobDescription-module-scss-module__mmqlOW__hero",
  "heroBranding": "jobDescription-module-scss-module__mmqlOW__heroBranding",
  "heroButtons": "jobDescription-module-scss-module__mmqlOW__heroButtons",
  "heroContent": "jobDescription-module-scss-module__mmqlOW__heroContent",
  "heroLogo": "jobDescription-module-scss-module__mmqlOW__heroLogo",
  "heroLogoWrapper": "jobDescription-module-scss-module__mmqlOW__heroLogoWrapper",
  "heroWrapper": "jobDescription-module-scss-module__mmqlOW__heroWrapper",
  "hidden": "jobDescription-module-scss-module__mmqlOW__hidden",
  "interestedButtonHero": "jobDescription-module-scss-module__mmqlOW__interestedButtonHero",
  "jobClosed": "jobDescription-module-scss-module__mmqlOW__jobClosed",
  "leave": "jobDescription-module-scss-module__mmqlOW__leave",
  "leaveFrom": "jobDescription-module-scss-module__mmqlOW__leaveFrom",
  "leaveTo": "jobDescription-module-scss-module__mmqlOW__leaveTo",
  "mobileCTA": "jobDescription-module-scss-module__mmqlOW__mobileCTA",
  "notification": "jobDescription-module-scss-module__mmqlOW__notification",
  "recruitingFor": "jobDescription-module-scss-module__mmqlOW__recruitingFor",
  "sections": "jobDescription-module-scss-module__mmqlOW__sections",
  "sectionsWrapper": "jobDescription-module-scss-module__mmqlOW__sectionsWrapper",
  "shareButtonDesktop": "jobDescription-module-scss-module__mmqlOW__shareButtonDesktop",
  "shareButtonMobile": "jobDescription-module-scss-module__mmqlOW__shareButtonMobile",
  "shareIconDesktop": "jobDescription-module-scss-module__mmqlOW__shareIconDesktop",
  "shareIconMobile": "jobDescription-module-scss-module__mmqlOW__shareIconMobile",
  "shareTextTablet": "jobDescription-module-scss-module__mmqlOW__shareTextTablet",
  "tabletCTA": "jobDescription-module-scss-module__mmqlOW__tabletCTA",
  "title": "jobDescription-module-scss-module__mmqlOW__title",
  "transition": "jobDescription-module-scss-module__mmqlOW__transition",
});
